import BringYourOwnTeamComponent from 'components/marketingSite/bringYourOwnTeam/BringYourOwnTeamComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { OwnTeam } from 'interfaces/own-team.interface';
import { Tech } from 'model';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import BringYourOwnTeamService from 'services/bring-your-own-team.service';
import { ServiceTechs } from 'services/service.techs';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getLocale } from 'utils/localize.utils';
import { getPublicPath } from 'utils/paths';

type BringYourOwnTeamPageProps = {
  techs: Tech[];
  teams: OwnTeam[];
  baseUrl?: string;
};

const BringYourOwnTeamPage: React.FC<BringYourOwnTeamPageProps> = ({
  techs,
  teams,
  baseUrl
}) => {
  const { t } = useI18n('bring-your-own-team');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('page_title')}
        url={APP_URLS.bringYourOwnTeam}
        desc={t('page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_bring_your_own_team.png'
        )}`}
      />
      <BringYourOwnTeamComponent techs={techs} teams={teams} />
    </>
  );
};

export default BringYourOwnTeamPage;

export const getStaticProps: GetStaticProps<
  BringYourOwnTeamPageProps
> = async ({ locale }) => {
  let techs: Tech[] = [];
  let teams: OwnTeam[] = [];

  try {
    techs = await ServiceTechs.getAll(
      getLocale(locale),
      'fake-token' // Needed just to make the call to the API URL directly, instead of the NextJS middleware (which is not available at SSR/Static Generation)
    );
    teams = await BringYourOwnTeamService.getAll();
  } catch (ex) {
    console.warn(
      `Could not get Bring your own teams content. Exception: ${ex}`
    );
  }

  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'bring-your-own-team'
      ])),
      baseUrl: config.appUrl,
      techs: JSON.parse(JSON.stringify(techs)),
      teams
    },
    revalidate: 30
  };
};
